import throttle from 'raf-throttle';

class TabAccordion extends HTMLElement {
  constructor() {
    super();
    this.tabsIsInit = false;
    this.accordionIsInit = false;
    this.currentTab = 0;
    this.responsiveSize = 760;
    this.$tabs = this.querySelectorAll('.tab-accordion__tab');
    this.$tabpanels = this.querySelectorAll('.tab-accordion__tabpanel');
    this.$toggleBtns = this.querySelectorAll('.tab-accordion__toggle-btn');
    this.setupEventListeners();
    // Check viewpoprt to init either tabs or accordion
    this.monitorViewport();
  }

  initTabs() {
    if (this.tabsIsInit) return;
    this.$tabpanels.forEach(($panel) => {
      $panel.classList.add('tab-accordion__tabpanel--is-hidden');
      $panel.removeAttribute('hidden');
      $panel.setAttribute('role', 'tabpanel');
      $panel.setAttribute('tabindex', '0');
    });
    this.tabsIsInit = true;
    this.accordionIsInit = false;
    // Show first tab my default and do not focus
    this.showTab(0, false);
  }

  initAccordion() {
    if (this.accordionIsInit) return;
    this.$tabpanels.forEach(($panel) => {
      $panel.classList.add('tab-accordion__tabpanel--is-hidden');
      $panel.setAttribute('hidden', true);
      $panel.setAttribute('role', 'region');
      $panel.removeAttribute('tabindex');
    });
    this.$toggleBtns.forEach(($btn) => {
      $btn.classList.remove('tab-accordion__toggle-btn--is-active');
      $btn.setAttribute('aria-expanded', false);
    });
    this.accordionIsInit = true;
    this.tabsIsInit = false;
  }

  toggleContent(targetTabID) {
    const $targetPanel = this.$tabpanels[targetTabID];
    const $targetToggleBtn = this.$toggleBtns[targetTabID];
    if (!$targetPanel && !$targetToggleBtn) return;

    if ($targetPanel.classList.contains('tab-accordion__tabpanel--is-hidden')) {
      // Show
      // Button
      $targetToggleBtn.classList.add('tab-accordion__toggle-btn--is-active');
      $targetToggleBtn.setAttribute('aria-expanded', true);
      // Panel
      $targetPanel.classList.remove('tab-accordion__tabpanel--is-hidden');
      $targetPanel.removeAttribute('hidden');
    } else {
      // Hide
      // Button
      $targetToggleBtn.classList.remove('tab-accordion__toggle-btn--is-active');
      $targetToggleBtn.setAttribute('aria-expanded', false);
      // Panel
      $targetPanel.classList.add('tab-accordion__tabpanel--is-hidden');
      $targetPanel.setAttribute('hidden', true);
    }
  }

  showTab(tabID = 0, focus = false) {
    this.currentTab = tabID;
    this.$tabpanels.forEach(($tabpanel, panelIndex) => {
      if (panelIndex === tabID) {
        $tabpanel.classList.remove('tab-accordion__tabpanel--is-hidden');
      } else {
        $tabpanel.classList.add('tab-accordion__tabpanel--is-hidden');
      }
    });
    this.$tabs.forEach(($tab, tabIndex) => {
      if (tabIndex === tabID) {
        $tab.setAttribute('aria-selected', true);
        $tab.removeAttribute('tabindex');
        $tab.classList.add('tab-accordion__tab--is-active');
        if (focus) $tab.focus();
      } else {
        $tab.setAttribute('aria-selected', false);
        $tab.classList.remove('tab-accordion__tab--is-active');
        // eslint-disable-next-line no-param-reassign
        $tab.tabIndex = -1;
      }
    });
  }

  showPreviousTab() {
    const tabCount = this.$tabs.length - 1;
    let targetTab = this.currentTab - 1;
    if (targetTab < 0) {
      targetTab = tabCount;
    }
    if (targetTab > tabCount) {
      targetTab = 0;
    }
    this.showTab(targetTab, true);
  }

  showNextTab() {
    const tabCount = this.$tabs.length - 1;
    let targetTab = this.currentTab + 1;
    if (targetTab < 0) {
      targetTab = tabCount;
    }
    if (targetTab > tabCount) {
      targetTab = 0;
    }
    this.showTab(targetTab, true);
  }

  checkViewport() {
    if (window.innerWidth > this.responsiveSize) {
      this.initTabs();
    } else {
      this.initAccordion();
    }
  }

  monitorViewport() {
    // Run on init
    this.checkViewport();
    const throttled = throttle(() => {
      this.checkViewport();
    });
    // Run on viewport resize
    window.addEventListener('resize', throttled);
  }

  setupEventListeners() {
    this.$tabs.forEach(($tab, tabIndex) => {
      $tab.addEventListener('keydown', (e) => this.keyboardEvents(e));
      $tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.showTab(tabIndex, true);
      });
    });
    this.$toggleBtns.forEach(($btn, tabIndex) => {
      $btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleContent(tabIndex);
      });
    });
  }

  keyboardEvents(event) {
    switch (event.key) {
      case 'ArrowLeft':
        this.showPreviousTab();
        break;
      case 'ArrowRight':
        this.showNextTab();
        break;
      case 'Home':
        this.showTab(0, true);
        event.stopPropagation();
        event.preventDefault();
        break;
      case 'End':
        this.showTab(this.$tabs.length - 1, true);
        event.stopPropagation();
        event.preventDefault();
        break;
      default:
        break;
    }
  }
}

export default function init() {
  customElements.define('tab-accordion', TabAccordion);
}
